<div class="btn-group animated-dropdown" dropdown #dropdown="bs-dropdown" (isOpenChange)="isOpen = $event">
    <div [id]="buttonId" class="toggle-group d-flex align-items-center" dropdownToggle [khA11yDropdownTrigger]="isOpen" [khA11yDropdownControls]="menuId" [khA11yLabel]="triggerAccessibleName">
        <span *ngIf="label" class="medium-title-text mr-xs">{{label}}</span>
        <ng-content select="[header]"></ng-content>
    </div>
    <ul [id]="menuId" khA11yMenu khA11yLabel [a11yLabelledBy]="buttonId" class="dropdown-menu border-radius-md p-4 mt-xs border-0" [ngClass]="{ 'dropdown-menu-right' : alignmentRight }" *dropdownMenu (keydown)="onMenuKeydown($event, dropdown)">
        <ng-content></ng-content>
    </ul>
</div>